/** Avoid uncaught NotFoundError when capture was already cleared (blur, lostpointercapture, race). */
export function safeReleasePointerCapture(element: Element, pointerId: number): void {
    try {
        element.releasePointerCapture(pointerId);
    } catch {
        /* ignore */
    }
}
